import { IDrugClass } from '@interfaces/lookups';

const handleGetBannedMedications = (
  existingDrugIds: number[],
  drugClasses: IDrugClass[],
): string[] => {
  if (!existingDrugIds || !drugClasses) {
    return [];
  }

  return drugClasses
    .filter((drugClass: IDrugClass) => existingDrugIds.includes(drugClass.id))
    .map((drugClass: IDrugClass) => drugClass.name);
};

export default handleGetBannedMedications;
